import { IOrderBalanceResponse } from "types/OrderBalance";

import { api } from ".";

// CLE-2849: SuperAdmin-only balance ledger. The endpoint reads Stripe/Finix live, so callers use
// the LAZY hook and fire it on demand; nothing loads it on page open, and it is never cached for long.
const orderBalanceQueries = api.injectEndpoints({
  endpoints: (builder) => ({
    getOrderBalance: builder.query<IOrderBalanceResponse, string>({
      query: (orderId) => ({ url: `orders/${orderId}/balance` }),
      keepUnusedDataFor: 0,
    }),
  }),
});

export const { useLazyGetOrderBalanceQuery } = orderBalanceQueries;
